<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Add Letter Message</h5>
      <form [formGroup]="AddNewMailMessage" (submit)="SubmitAddNewMailMessage()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Title</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">Enter the title.</small>
          </div>

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Letter Type </label>
            <select formControlName="LetterType" class="custom-select">
              <option value="0">Select</option>
              <option value="1">Outgoing Letter</option>
              <option value="2">Custody Receipt</option>
              <option value="3">Instrument Reception</option>
              <option value="4">Scheduling Letter</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Text</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">Enter the text.</small>
          </div>
        </div>

          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewMailMessage.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
          <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
          <button routerLink="/MailMessage" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

